/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetLocaleConsentAcceptanceInternalRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/get_locale_consent_acceptance_internal.pb'
import {GetLocaleConsentAcceptanceResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/get_locale_consent_acceptance.pb'


export const getLocaleConsentAcceptanceInternal = (request: GetLocaleConsentAcceptanceInternalRequest, options?: CashRequestOptions) => post<GetLocaleConsentAcceptanceInternalRequest, GetLocaleConsentAcceptanceResponse>("/2.0/cash/get-locale-consent-acceptance-internal", request, {...options, rejectOnError: true })